import HorizontalLayout from '../components/layouts/HorizontalLayout';
import VerticalLayout from '../components/layouts/VerticalLayout';
import { NotFoundIconUrl } from '../icons/Icons';

const NotFoundErrorPage = () => {
  return (
    <HorizontalLayout style={styles.container}>
      <VerticalLayout>
        <span style={styles.title}>Oops!</span>
        <span style={styles.subtext}>We couldn't find the page you're looking for.</span>
        <a style={styles.link} href={'https://admin.opendoor.com/vendor/invoices'}>
          Back to homepage
        </a>
      </VerticalLayout>
      <img src={NotFoundIconUrl} alt="" data-testid="not-found-icon" />
    </HorizontalLayout>
  );
};

export default NotFoundErrorPage;

const styles = {
  container: {
    backgroundColor: 'white',
    minHeight: '94vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    fontWeight: '600',
    fontSize: 32,
  },
  subtext: {
    color: '#354C63',
    fontWeight: '400',
    fontSize: 16,
    marginTop: '2vh',
    height: '100%',
    width: '11vw',
  },
  link: {
    fontWeight: '500',
    color: '#1D75CF',
    fontSize: 16,
    marginTop: '4vh',
  },
};
